import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, CSSResult } from 'lit'
import { csFontBodyS, csFontCaptionS } from 'elements/_shared/fonts.style.js'
import { csColorBackground, csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const cseBadge = {
  display: css`var(--cse-badge-display, inline-flex)`,
  borderWidth: css`var(--cse-badge-border-width, ${csBorder.width})`,
  borderRadius: css`var(--cse-badge-border-radius, ${csBorder.radiusMinimal})`,
  columnGap: css`var(--cse-badge-column-gap, ${csSpacing.spacing03})`,
  fontFamily: css`var(--cse-badge-font-family, ${csFontBodyS.fontFamily})`,
  fontSize: css`var(--cse-badge-font-size, ${csFontBodyS.fontSize})`,
  fontWeight: css`var(--cse-badge-font-weight, ${csFontBodyS.fontWeight})`,
  lineHeight: css`var(--cse-badge-line-height, ${csFontBodyS.lineHeight})`,
  letterSpacing: css`var(--cse-badge-letter-spacing, ${csFontBodyS.letterSpacing})`,
  paddingBlock: css`var(--cse-badge-padding-y, ${csSpacing.spacing01})`,
  paddingInline: css`var(--cse-badge-padding-x, ${csSpacing.spacing05})`,
  minHeight: css`var(--cse-badge-min-height, 24px)`,

  borderedBackgroundColor: css`var(--cse-badge-bordered-background-color, ${csColorBackground.primary})`,
  floatingBorderColor: css`var(--cse-badge-floating-border-color, ${csColorBackground.primary})`,
  floatingBorderWidth: css`var(--cse-badge-floating-border-width, 2px)`,
  floatingBorderRadius: css`var(--cse-badge-floating-border-radius, ${csBorder.radiusFull})`,
  floatingMinWidth: css`var(--cse-badge-floating-min-width, 29px)`,

  smallFontSize: css`var(--cse-badge-small-font-size, ${csFontCaptionS.fontSize})`,
  smallFontWeight: css`var(--cse-badge-small-font-weight, ${csFontCaptionS.fontWeight})`,
  smallLineHeight: css`var(--cse-badge-small-line-height, ${csFontCaptionS.lineHeight})`,
  smallLetterSpacing: css`var(--cse-badge-small-letter-spacing, ${csFontCaptionS.letterSpacing})`,
  smallPaddingBlock: css`var(--cse-badge-small-padding-y, ${csSpacing.spacing01})`,
  smallPaddingInline: css`var(--cse-badge-small-padding-x, ${csSpacing.spacing04})`,
  smallTextTransform: css`var(--cse-badge-small-text-transform, uppercase)`,
  smallMinHeight: css`var(--cse-badge-small-min-height, 20px)`,

  smallFloatingMinWidth: css`var(--cse-badge-small-floating-min-width, 22px)`,

  defaultBackgroundColor: css`var(--cse-badge-default-background-color, ${csColorBackground.secondary})`,
  defaultColor: css`var(--cse-badge-default-color, ${csColorText.body})`,
  infoBackgroundColor: css`var(--cse-badge-info-background-color, ${csColorFunctional.info})`,
  infoColor: css`var(--cse-badge-info-color, ${csColorText.white})`,
  successBackgroundColor: css`var(--cse-badge-success-background-color, ${csColorFunctional.success})`,
  successColor: css`var(--cse-badge-success-color, ${csColorText.white})`,
  errorBackgroundColor: css`var(--cse-badge-error-background-color, ${csColorFunctional.error})`,
  errorColor: css`var(--cse-badge-error-color, ${csColorText.white})`,
  warningBackgroundColor: css`var(--cse-badge-warning-background-color, ${csColorFunctional.warning})`,
  warningColor: css`var(--cse-badge-warning-color, ${csColorText.white})`,
  newBackgroundColor: css`var(--cse-badge-new-background-color, ${csColorFunctional.new})`,
  newColor: css`var(--cse-badge-new-color, ${csColorText.white})`,
  ourChoiceBackgroundColor: css`var(--cse-badge-our-choice-background-color, ${csColorFunctional.ourChoice})`,
  ourChoiceColor: css`var(--cse-badge-our-choice-color, ${csColorText.white})`,
  bestsellerBackgroundColor: css`var(--cse-badge-bestseller-background-color, ${csColorFunctional.bestseller})`,
  bestsellerColor: css`var(--cse-badge-bestseller-color, ${csColorText.white})`,
  saleBackgroundColor: css`var(--cse-badge-sale-background-color, ${csColorFunctional.sale})`,
  saleColor: css`var(--cse-badge-sale-color, ${csColorText.white})`,
  premiumBackgroundColor: css`var(--cse-badge-premium-background-color, ${csColorFunctional.highlight})`,
  premiumColor: css`var(--cse-badge-premium-color, ${csColorText.body})`,
}

export const style: CSSResult = css`
  .cse-badge {
    display: ${cseBadge.display};
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    background: ${cseBadge.defaultBackgroundColor};
    border-radius: ${cseBadge.borderRadius};
    color: ${cseBadge.defaultColor};
    column-gap: ${cseBadge.columnGap};
    font-family: ${cseBadge.fontFamily};
    font-size: ${cseBadge.fontSize};
    font-weight: ${cseBadge.fontWeight};
    line-height: ${cseBadge.lineHeight};
    letter-spacing: ${cseBadge.letterSpacing};
    padding-block: ${cseBadge.paddingBlock};
    padding-inline: ${cseBadge.paddingInline};
    min-height: ${cseBadge.minHeight};
  }

  .cse-badge.size-small {
    font-size: ${cseBadge.smallFontSize};
    font-weight: ${cseBadge.smallFontWeight};
    line-height: ${cseBadge.smallLineHeight};
    letter-spacing: ${cseBadge.smallLetterSpacing};
    padding-block: ${cseBadge.smallPaddingBlock};
    padding-inline: ${cseBadge.smallPaddingInline};
    text-transform: ${cseBadge.smallTextTransform};
    min-height: ${cseBadge.smallMinHeight};
  }

  /* DEFAULT */
  .cse-badge.composition-bordered {
    background-color: ${cseBadge.borderedBackgroundColor};
    border-style: solid;
    border-width: ${cseBadge.borderWidth};
    border-color: ${cseBadge.defaultColor};
  }

  .cse-badge.composition-simple {
    background: none;
    border: none;
    padding: 0;
  }

  .cse-badge.composition-floating {
    border-style: solid;
    border-width: ${cseBadge.floatingBorderWidth};
    border-color: ${cseBadge.floatingBorderColor};
    border-radius: ${cseBadge.floatingBorderRadius};
    min-width: ${cseBadge.floatingMinWidth};
  }

  .cse-badge.composition-floating.size-small {
    min-width: ${cseBadge.smallFloatingMinWidth};
  }

  /* ERROR */
  .cse-badge.variant-error {
    background-color: ${cseBadge.errorBackgroundColor};
    color: ${cseBadge.errorColor};
  }

  .cse-badge.variant-error.composition-bordered {
    background-color: ${cseBadge.borderedBackgroundColor};
    border-color: ${cseBadge.errorBackgroundColor};
    color: ${cseBadge.errorBackgroundColor};
  }

  .cse-badge.variant-error.composition-simple {
    background-color: transparent;
    color: ${cseBadge.errorBackgroundColor};
  }

  /* INFO */
  .cse-badge.variant-info {
    background-color: ${cseBadge.infoBackgroundColor};
    color: ${cseBadge.infoColor};
  }

  .cse-badge.variant-info.composition-bordered {
    background-color: ${cseBadge.borderedBackgroundColor};
    border-color: ${cseBadge.infoBackgroundColor};
    color: ${cseBadge.infoBackgroundColor};
  }

  .cse-badge.variant-info.composition-simple {
    background-color: transparent;
    color: ${cseBadge.infoBackgroundColor};
  }

  /* SUCCESS */
  .cse-badge.variant-success {
    background-color: ${cseBadge.successBackgroundColor};
    color: ${cseBadge.successColor};
  }

  .cse-badge.variant-success.composition-bordered {
    background-color: ${cseBadge.borderedBackgroundColor};
    border-color: ${cseBadge.successBackgroundColor};
    color: ${cseBadge.successBackgroundColor};
  }

  .cse-badge.variant-success.composition-simple {
    background-color: transparent;
    color: ${cseBadge.successBackgroundColor};
  }

  /* WARNING */
  .cse-badge.variant-warning {
    background-color: ${cseBadge.warningBackgroundColor};
    color: ${cseBadge.warningColor};
  }

  .cse-badge.variant-warning.composition-bordered {
    background-color: ${cseBadge.borderedBackgroundColor};
    border-color: ${cseBadge.warningBackgroundColor};
    color: ${cseBadge.warningBackgroundColor};
  }

  .cse-badge.variant-warning.composition-simple {
    background-color: transparent;
    color: ${cseBadge.warningBackgroundColor};
  }

  /* NEW */
  .cse-badge.variant-new {
    background-color: ${cseBadge.newBackgroundColor};
    color: ${cseBadge.newColor};
  }

  .cse-badge.variant-new.composition-bordered {
    background-color: ${cseBadge.borderedBackgroundColor};
    border-color: ${cseBadge.newBackgroundColor};
    color: ${cseBadge.newBackgroundColor};
  }

  .cse-badge.variant-new.composition-simple {
    background-color: transparent;
    color: ${cseBadge.newBackgroundColor};
  }

  /* OUR CHOICE */
  .cse-badge.variant-our-choice {
    background-color: ${cseBadge.ourChoiceBackgroundColor};
    color: ${cseBadge.ourChoiceColor};
  }

  .cse-badge.variant-our-choice.composition-bordered {
    background-color: ${cseBadge.borderedBackgroundColor};
    border-color: ${cseBadge.ourChoiceBackgroundColor};
    color: ${cseBadge.ourChoiceBackgroundColor};
  }

  .cse-badge.variant-our-choice.composition-simple {
    background-color: transparent;
    color: ${cseBadge.ourChoiceBackgroundColor};
  }

  /* BESTSELLER */
  .cse-badge.variant-bestseller {
    background-color: ${cseBadge.bestsellerBackgroundColor};
    color: ${cseBadge.bestsellerColor};
  }

  .cse-badge.variant-bestseller.composition-bordered {
    background-color: ${cseBadge.borderedBackgroundColor};
    border-color: ${cseBadge.bestsellerBackgroundColor};
    color: ${cseBadge.bestsellerBackgroundColor};
  }

  .cse-badge.variant-bestseller.composition-simple {
    background-color: transparent;
    color: ${cseBadge.bestsellerBackgroundColor};
  }

  /* SALE */
  .cse-badge.variant-sale {
    background-color: ${cseBadge.saleBackgroundColor};
    color: ${cseBadge.saleColor};
  }

  .cse-badge.variant-sale.composition-bordered {
    background-color: ${cseBadge.borderedBackgroundColor};
    border-color: ${cseBadge.saleBackgroundColor};
    color: ${cseBadge.saleBackgroundColor};
  }

  .cse-badge.variant-sale.composition-simple {
    background-color: transparent;
    color: ${cseBadge.saleBackgroundColor};
  }

  /* PREMIUM */
  .cse-badge.variant-premium {
    background-color: ${cseBadge.premiumBackgroundColor};
    color: ${cseBadge.premiumColor};
  }

  .cse-badge.variant-premium.composition-bordered {
    background-color: ${cseBadge.borderedBackgroundColor};
    border-color: ${cseBadge.premiumBackgroundColor};
    color: ${cseBadge.premiumBackgroundColor};
  }

  .cse-badge.variant-premium.composition-simple {
    background-color: transparent;
    color: ${cseBadge.premiumBackgroundColor};
  }
`
